import { render, staticRenderFns } from "./LicenseSection.vue?vue&type=template&id=c0255868&scoped=true&"
import script from "./LicenseSection.vue?vue&type=script&lang=js&"
export * from "./LicenseSection.vue?vue&type=script&lang=js&"
import style0 from "./LicenseSection.vue?vue&type=style&index=0&id=c0255868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0255868",
  null
  
)

export default component.exports